export enum ReactionFromEnum {
  HOME = 'home',
  ENDED_BOOKING = 'ended_booking',
}

export enum ReactionChoiceModalBodyEnum {
  VALIDATION = 'validation',
  REDIRECTION = 'redirection',
}
